export default __webpack_public_path__ + "static/homeRobotCard-5623413fb99e2a53260498717e32365d.png";